import React from "react";

const WHATSAPP_NUMBER = "447435324947";

const Footer = () => (
  <footer className="py-12 bg-slate-900/50 border-t border-slate-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2">
          <span className="text-xl font-bold text-white font-['Manrope']">
            Smart<span className="text-blue-500">IT</span>
          </span>
          <span className="text-slate-500 text-sm">© 2024</span>
        </div>
        <div className="flex items-center gap-6">
          <a href="https://www.facebook.com/smartitsolution2020" target="_blank" rel="noopener noreferrer" 
            className="text-slate-400 hover:text-blue-500 transition-colors">Facebook</a>
          <a href="mailto:smartit_itsolutions@outlook.com" className="text-slate-400 hover:text-blue-500 transition-colors">Email</a>
          <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer"
            className="text-slate-400 hover:text-green-500 transition-colors">WhatsApp</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
